import React, { forwardRef } from 'react'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'

const Zoomable = forwardRef(({ children, disabled }, ref) => {
  return (
    <TransformWrapper ref={ref} initialScale={1} maxScale={4} disabled={disabled}>
      <TransformComponent>{children}</TransformComponent>
    </TransformWrapper>
  )
})

Zoomable.displayName = 'Zoomable'

export default Zoomable
